import React from 'react';

import GridSvg from 'assets/icons/gridView.svg';
import ListSvg from 'assets/icons/listView.svg';

export interface GridViewProps {
  activeGrid?: string;
  setActiveGrid: Function;
}

const GridView = ({ activeGrid, setActiveGrid }: GridViewProps) => {
  const wales = 0;
  return (
    <div className="flex my-6">
      <button
        onClick={() => setActiveGrid('grid')}
        className={`${
          activeGrid === 'grid' ? 'bg-primary-2' : ''
        } border border-primary-2 rounded-l-md p-2 cursor-pointer`}
      >
        <img src={GridSvg} alt="" />
      </button>
      <button
        onClick={() => setActiveGrid('list')}
        className={`${
          activeGrid === 'list' ? 'bg-primary-2' : ''
        } border border-primary-2 rounded-r-md p-2 ml-1 cursor-pointer`}
      >
        <img src={ListSvg} alt="" />
      </button>
    </div>
  );
};

export default GridView;
